import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { useTracking } from "react-tracking";
import Typography from "@material-ui/core/Typography";
import { LinearProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function Loading(match) {
  return (
    <div style={{ flex: 1, height: "1000px" }}>
      <LinearProgress color="primary" />
      <Grid
        container
        direction="column"
        alignItems="center"
        alignContent="center"
      >
        <Grid
          item
          style={{ width: "auto", margin: "50px", marginTop: "10%" }}
          alignItems="center"
          alignContent="center"
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/logosDashport%2FDASHPORT_isotipo%20paraicono.png?alt=media&token=9023e0f0-397f-418e-9349-edee2cc01bd0"
            alt="dashport"
            height={300}
          />
        </Grid>
      </Grid>
    </div>
  );
}
